import * as React from 'react';
import {SVGProps} from 'react';
const Curve2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="1em"
    viewBox="0 0 239 227"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_40000935_5956)">
      <path
        d="M5.5693 227.616C16.9368 212.399 33.4264 201.055 51.6507 195.742C71.7056 189.899 92.4664 192.657 112.894 194.504C132.287 196.262 152.811 196.914 170.94 188.638C180.461 184.287 188.593 177.44 195.752 169.905C203.512 161.744 210.545 152.861 217.595 144.083C232.447 125.583 246.605 106.5 259.478 86.5645C261.078 84.0856 262.666 81.5877 264.231 79.0873C265.934 76.3538 261.714 73.6715 260.012 76.405C247.41 96.6199 233.469 115.96 218.738 134.678C211.714 143.603 204.601 152.519 197.1 161.057C190.218 168.9 182.682 176.468 173.566 181.693C156.491 191.48 136.066 191.436 117.012 189.87C96.3496 188.17 75.3524 184.871 54.8522 189.755C36.0844 194.189 18.6648 204.611 5.99854 219.168C4.38575 221.034 2.8213 222.954 1.34125 224.928C0.532631 226.014 1.03811 227.698 2.11833 228.385C3.33358 229.157 4.76068 228.702 5.5693 227.616Z"
        fill="url(#paint0_linear_40000935_5956)"
      />
    </g>
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_40000935_5956"
        x1={61.0278}
        x2={198.24}
        y1={260.015}
        y2={44.1651}
      >
        <stop stopColor="#FF3A8B" />
        <stop
          offset={1}
          stopColor="#FFBA4A"
        />
      </linearGradient>
      <clipPath id="clip0_40000935_5956">
        <rect
          fill="white"
          height={143.61}
          transform="translate(0 227.039) rotate(-57.5566)"
          width={269.03}
        />
      </clipPath>
    </defs>
  </svg>
);
export default Curve2;
